import { useSelector } from "react-redux";
import axios, { AxiosError, AxiosResponse } from "axios";
import { Trip } from "../objects/trip";
import { AppState } from "../../../reducers";

type Callback = (data: TripCreateData) => Promise<Trip | null>

type Options = {
    onTrigger: () => void,
    onSuccess: (trip: Trip) => void,
    onError: (error: AxiosError) => void,
    onFinally: () => void
}

export type TripCreateData = {
    circuit_type: boolean,
    currency: number | null,
    target_client: number,
    circuit: number,
    data: {
        start_date: string,
        end_date: string,
        destination: number,
        travelers: number[],
    },
    user_to?: number,
    is_by_day_view?: boolean
}

export function useTripCreate(options: Options): Callback {
    const clientId = useSelector((state: AppState) => state.header.client_id);

    return async (data) => {
        if (clientId !== null) {
            try {
                options.onTrigger();
                const response = await makeRequest(clientId, data);
                options.onSuccess(response.data);
                return response.data;
            } catch (error: any) {
                options.onError(error);
            } finally {
                options.onFinally();
            }
        }
        return null;
    };
}

function makeRequest(
    clientId: number,
    data: TripCreateData
): Promise<AxiosResponse<Trip>> {
    return axios.post(
        `${API_HREF}client/${clientId}/trip/`,
        data,
        {
            headers: {
                'Authorization': `Token ${localStorage.getItem('token')}`,
            },
        }
    );
}